import { Card, CardBody, Col, Row } from "reactstrap";
import { H4, SVG } from "../../../../AbstractElements";
import { newOrdersData } from "../../../../Data/Widgets/GeneralWidgetsData";
import OrderWidgets from "./OrderWidgets/OrderWidgets";

const NewOrders = () => {
  return (
    <Col xxl="5" xl="8" className="box-col-12">
      <Row className="g-sm-3 height-equal-2 widget-charts">
        {newOrdersData.map((data, i) => (
          <Col sm="6" key={i}>
            <Card className="small-widget mb-sm-0">
              <CardBody className={data.color}>
                <span className="f-light">{data.title}</span>
                <div className="d-flex align-items-end gap-1">
                  <H4>{data.number}</H4>
                  <span className={`font-${data.color} f-12 f-w-500`}>
                    <i className={data.icon} />
                    <span>{data.percentage}</span>
                  </span>
                </div>
                <div className="bg-gradient">
                  <SVG className="stroke-icon svg-fill" iconId={data.svg} />
                </div>
              </CardBody>
            </Card>
          </Col>
        ))}
        <OrderWidgets />
      </Row>
    </Col>
  );
};

export default NewOrders;
